const System = {
  SETTING: process.env.REACT_APP_SYSTEM_SETTING!!,
  ADMIN_TOKEN: process.env.REACT_APP_WEB_ADMIN_TOKEN!!,
  ADMIN_REFRESH_TOKEN: process.env.REACT_APP_WEB_ADMIN_REFRESH_TOKEN!!,
};

export default System;
